"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType = void 0;
var TransactionType;
(function (TransactionType) {
    TransactionType[TransactionType["Legacy"] = 0] = "Legacy";
    TransactionType[TransactionType["EIP2930AccessList"] = 1] = "EIP2930AccessList";
    //todo: this should be EIP1559FeeMarket
    //https://github.com/trufflesuite/ganache/issues/4462
    TransactionType[TransactionType["EIP1559AccessList"] = 2] = "EIP1559AccessList";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
//# sourceMappingURL=rpc-transaction.js.map